import React, { useEffect, ReactNode } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageStateSelectors } from '../../../../../app/page/page-state/page-state.selectors';
import { initialSettingsPage } from '../../../../../app/page/settings/settings.actions';
import { useSelectWithParams } from '../../../../../utils/selector.utils';
import { PageLayout } from '../../../common/PageLayout';
import { useHistory } from 'react-router-dom';
import { FaDollarSign } from 'react-icons/fa';
import { authSelectors } from '../../../../../app/auth/auth.selectors';
import { settingsSelectors } from '../../../../../app/resource/settings/settings.selectors';
import { userSelectors } from '../../../../../app/resource/user/user.selectors';
import { Navigation } from './Navigation';

type Props = {
  children: ReactNode;
  activeTab: 'annualsAndPeriods' | 'generalSettings' | 'integrations';
};

export const SettingsLayout = ({ children, activeTab }: Props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const loggedUserisAdmin = useSelector(authSelectors.selectUserIsAdmin);
  const loggedUserId = useSelector(authSelectors.selectLoggedUser);
  const loggedUser = useSelectWithParams(userSelectors.selectResourceById, loggedUserId ? loggedUserId : '');
  const settings = useSelectWithParams(
    settingsSelectors.selectResourceById,
    loggedUser?.tenantId ? loggedUser.tenantId : '',
  );

  const showLoader = useSelectWithParams(pageStateSelectors.selectPageInProgress, 'settings');

  const handleNavigation = (item: string) => {
    const basePath = '/settings/administration';
    switch (item) {
      case 'annualsAndPeriods':
        history.push(`${basePath}/annuals-and-periods`);
        break;
      case 'generalSettings':
        history.push(`${basePath}/general-settings`);
        break;
      case 'integrations':
        history.push(`${basePath}/integrations`);
        break;
      default:
        history.push(`${basePath}/general-settings`);
    }
  };

  useEffect(() => {
    dispatch(initialSettingsPage());
  }, [dispatch]);

  return (
    settings && (
      <PageLayout showLoader={showLoader} showHide={true}>
        {!showLoader && (
          <div className="row mb-25">
            <div className="col-12">
              <div className="panel">
                <div className="panel-header no-border">
                  <h2 className="bold">Settings</h2>
                </div>
                <div className="panel-body pt-0 ho-hover">
                  <div className="border-radius-1 lightGray-bg p-2">
                    <div className="row">
                      <div className="col max-250">
                        {loggedUserisAdmin && (
                          <button
                            className="directory-button panel small-panel flex aic px-1 mb-1 active"
                            onClick={() => history.push('/settings/administration')}
                          >
                            <i className="icon-settings mr-1 blueGray" /> Administration
                          </button>
                        )}
                        <button
                          className="directory-button panel small-panel flex aic px-1 mb-1"
                          onClick={() => history.push('/settings/profile')}
                        >
                          <i className="icon-user mr-1 blueGray" /> Profile
                        </button>
                        {loggedUserisAdmin && (
                          <button
                            className="directory-button panel small-panel flex aic px-1 mb-1"
                            onClick={() => history.push('/settings/subscription')}
                          >
                            <FaDollarSign size={14} className="mr-1 blueGray" /> Subscription
                          </button>
                        )}
                      </div>
                      <div className="col">
                        <div className="panel w100">
                          <div className="panel-header no-border">
                            <h2 className="bold">Administration</h2>
                          </div>
                          <div className="panel-body pt-0">
                            <div className="border-radius-1 lightGray-bg p-2">
                              <div className="panel w100 p-3">
                                <div className="row">
                                  <Navigation onNavigationClick={handleNavigation} activeItem={activeTab} />
                                  {children}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </PageLayout>
    )
  );
};
